import React, { useRef, useEffect, useState, useCallback, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ENDPOINT } from "constants/variables";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import SendIcon from "@mui/icons-material/Send";
import Textarea from "@mui/joy/Textarea";
import { TextField } from "@mui/material";
import PropTypes from "prop-types";
import { helpHttp } from "service/HelpHttp";
import { setLoading } from "reducers/loadingSlice";
import { LoadingNews } from "components/utils/LoadingNews";
import { successErrorAction, warningErrorAction } from "actions/ErrorActions";
import ReportTemplateShipping from "pages/shipping/generatePDF/ReportTemplateShipping";
import "css/generalSettings.css";
import "css/customDialog.css";
import "css/shippingEmailResponsive.css";
const initialStateShippingSendEmail = {
  id: "",
  ownshipping_id: "",
  defaultStore_id: 0,
  useraccount_id: 0,
  defaultformatnumber: 1,
  number_shipping: "",
  date_shipping: "",
  rel_trans_store_id: 0,
  rel_trans_documentid: "",
  rel_trans_tradename: "",
  rel_trans_street: "",
  vehiclestore_id: 0,
  vehiclestore_licenseplate: "",
  vehiclestore_trailer: "",
  vehiclestore_documentid: "",
  vehiclestore_defaultdriver: "",
  opt_tras_store_id: 0,
  opt_tras_documentid: "",
  opt_tras_tradename: "",
  opt_tras_street: "",
  dest_tras_store_id: 0,
  dest_tras_documentid: "",
  dest_tras_tradename: "",
  dest_tras_street: "",
  weight: 0,
  price_weight: 0,
  service_1: "",
  price_service_1: 0,
  service_2: "",
  price_service_2: 0,
  service_3: "",
  price_service_3: 0,
  origin_street: "",
  destine_street: "",
  workplace: "",
  tax: 0,
  taxincluded: false,
  observations: "",
  signature_driver: "",
  signature_charger: "",
  formdi_id: 0,
  ownformdi_id: "",
  totalnetoservice: 0,
  totalnetoshipping: 0,
  paymenttype_id: 1,
  paymenttype_code: "",
  paymenttype_namees: "",
  paymenttype_nameen: "",
  semitrailertype_id: 0,
  semitrailertype_namees: "",
  semitrailertype_nameen: "",
  cranemodel_id: 0,
  cranemodel_namees: "",
  cranemodel_nameen: "",
  hours: null,
  withcrane: false,
  withoutcrane: false,
  adr: false,
  others: false,
  linesshipping: []
};
const initialStateEMAIL = {
  id: "",
  defaultStore_id: 0,
  useraccount_id: 0,
  store_EmailTo: "",
  subjectEmail: "",
  contentEmail: "",
  filetosend: []
};
const initialEmailToSelect = [{
  id: "",
  email: ""
}];
const INVALID_CHARS_REGEX = /[\\!$%&|<>?{}~"']+/;
const CLEAN_SEARCH_REGEX = /[.;\-/\\|]/g;
function useDebouncedCallback(callback, delay = 300) {
  const cbRef = useRef(callback);
  const timeoutRef = useRef(null);
  useEffect(() => {
    cbRef.current = callback;
  }, [callback]);
  return useCallback((...args) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = setTimeout(() => {
      if (cbRef.current) {
        cbRef.current(...args);
      }
    }, delay);
  }, [delay]);
}
const ShippingSendEmail = ({
  id,
  showModalShippingSendEmail,
  typeOfList
}) => {
  const {
    t,
    i18n
  } = useTranslation(["listDataShipping"]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = useSelector(state => state.loginUser.token);
  const defaultStore = useSelector(state => state.loginUser.defaultStore);
  const useraccount_id = useSelector(state => state.loginUser.useraccount_id);
  const footeremail = useSelector(state => state.formatDIUser.footeremail);
  const isLoadingData = useSelector(state => state.loading.isLoading);
  const [dataShipping, setDataShipping] = useState(initialStateShippingSendEmail);
  const [formEMAIL, setFormEMAIL] = useState(initialStateEMAIL);
  const [errorsEMAIL, setErrorsEMAIL] = useState({});
  const [pdfBlob, setPdfBlob] = useState(null);
  const [emailToSelect, setEmailToSelect] = useState(initialEmailToSelect);
  const [filteredEmail, setFilteredEmail] = useState([]);
  const [highlightedIndexEmail, setHighlightedIndexEmail] = useState(-1);
  const mountedRef = useRef(true);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  const pdfUrl = useMemo(() => {
    if (!pdfBlob) return "";
    return URL.createObjectURL(pdfBlob);
  }, [pdfBlob]);
  useEffect(() => {
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl);
      }
    };
  }, [pdfUrl]);
  const pdfViewer = useMemo(() => {
    if (!pdfUrl) return null;
    return <iframe src={pdfUrl} title="PDF Preview" style={{
      width: "100%",
      height: "100%",
      border: "none"
    }} />;
  }, [pdfUrl]);
  const validateFormEmail = useCallback(currentFormEmail => {
    const formToValidate = currentFormEmail || initialStateEMAIL;
    const errs = {};
    const emailTo = formToValidate.store_EmailTo ?? "";
    const subjectEmail = formToValidate.subjectEmail ?? "";
    const contentEmail = formToValidate.contentEmail ?? "";
    if (!emailTo.trim()) {
      errs.store_EmailTo = "Text_FieldSendEmailToRequired";
    } else if (INVALID_CHARS_REGEX.test(emailTo)) {
      errs.store_EmailTo = "Text_TextNoValid";
    }
    if (INVALID_CHARS_REGEX.test(subjectEmail)) {
      errs.subjectEmail = "Text_TextNoValid";
    }
    if (INVALID_CHARS_REGEX.test(contentEmail)) {
      errs.contentEmail = "Text_TextNoValid";
    }
    return errs;
  }, []);
  const resetStateAndClose = useCallback(() => {
    setDataShipping(initialStateShippingSendEmail);
    setFormEMAIL(initialStateEMAIL);
    setErrorsEMAIL({});
    setPdfBlob(null);
    setEmailToSelect(initialEmailToSelect);
    setFilteredEmail([]);
    setHighlightedIndexEmail(-1);
    dispatch(setLoading(false));
    navigate(typeOfList === "1" ? "/shipping" : "/shippingended");
  }, [dispatch, navigate, typeOfList]);
  const handleCloseSendEmail = useCallback(() => {
    resetStateAndClose();
  }, [resetStateAndClose]);
  useEffect(() => {
    if (!showModalShippingSendEmail) return;
    const onKeyDown = e => {
      if (e.key === "Escape") {
        resetStateAndClose();
      }
    };
    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [showModalShippingSendEmail, resetStateAndClose]);
  const blobToBase64 = useCallback(blob => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const result = String(reader.result || "");
        const base64 = result.includes(",") ? result.split(",")[1] : "";
        resolve(base64);
      };
      reader.onerror = reject;
    });
  }, []);
  const scrollToElement = useCallback(index => {
    const dropdown = document.querySelector(".email-suggest-dropdown");
    const item = dropdown?.children?.[index];
    if (item) {
      item.scrollIntoView({
        behavior: "smooth",
        block: "nearest"
      });
    }
  }, []);
  const runFilterEmail = useCallback(searchValue => {
    const q = (searchValue ?? "").toLowerCase().trim();
    if (!q) {
      setFilteredEmail([]);
      setHighlightedIndexEmail(-1);
      return;
    }
    const filtered = (emailToSelect || []).filter(item => item?.email).filter(item => item.email.toLowerCase().includes(q)).slice(0, 20);
    setFilteredEmail(filtered);
    setHighlightedIndexEmail(filtered.length > 0 ? 0 : -1);
  }, [emailToSelect]);
  const debouncedHandleSearchEmail = useDebouncedCallback(runFilterEmail, 300);
  const handleSelectEmail = useCallback(emailObj => {
    if (!emailObj) return;
    setFormEMAIL(prev => ({
      ...prev,
      store_EmailTo: emailObj.email ?? ""
    }));
    setFilteredEmail([]);
    setHighlightedIndexEmail(-1);
  }, []);
  const handleKeyDownEmail = useCallback(event => {
    if (event.key === "ArrowDown") {
      if (filteredEmail.length === 0 && !(formEMAIL.store_EmailTo ?? "").trim()) {
        const validEmails = (emailToSelect || []).filter(item => item?.email);
        setFilteredEmail(validEmails);
        setHighlightedIndexEmail(validEmails.length > 0 ? 0 : -1);
        return;
      }
      setHighlightedIndexEmail(prevIndex => {
        const nextIndex = prevIndex < filteredEmail.length - 1 ? prevIndex + 1 : prevIndex;
        scrollToElement(nextIndex);
        return nextIndex;
      });
      return;
    }
    if (event.key === "ArrowUp") {
      setHighlightedIndexEmail(prevIndex => {
        const nextIndex = prevIndex > 0 ? prevIndex - 1 : prevIndex;
        scrollToElement(nextIndex);
        return nextIndex;
      });
      return;
    }
    if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexEmail >= 0) {
      if (highlightedIndexEmail < filteredEmail.length) {
        event.preventDefault();
        handleSelectEmail(filteredEmail[highlightedIndexEmail]);
      }
      return;
    }
    if (event.key === "Escape") {
      const inputValue = (formEMAIL.store_EmailTo ?? "").toLowerCase();
      const isValid = (emailToSelect || []).some(item => (item?.email ?? "").toLowerCase() === inputValue);
      if (!isValid) {
        setFormEMAIL(prev => ({
          ...prev,
          store_EmailTo: ""
        }));
      }
      setFilteredEmail([]);
      setHighlightedIndexEmail(-1);
    }
  }, [filteredEmail, formEMAIL.store_EmailTo, emailToSelect, highlightedIndexEmail, handleSelectEmail, scrollToElement]);
  const handleBlurDropdownContainer = useCallback(event => {
    if (!event?.currentTarget) return;
    if (!event.currentTarget.contains(event.relatedTarget)) {
      setFilteredEmail([]);
      setHighlightedIndexEmail(-1);
    }
  }, []);
  const handleChangeDataEditEmail = useCallback(e => {
    const {
      name,
      value
    } = e.target;
    setFormEMAIL(prev => ({
      ...prev,
      [name]: value ?? ""
    }));
  }, []);
  const handleBlurDataEditEmail = useCallback(e => {
    const {
      name,
      value
    } = e.target;
    const nextForm = {
      ...formEMAIL,
      [name]: value ?? ""
    };
    setErrorsEMAIL(validateFormEmail(nextForm));
  }, [formEMAIL, validateFormEmail]);
  const handleSubmitSendEmail = useCallback(async () => {
    const currentErrors = validateFormEmail(formEMAIL);
    setErrorsEMAIL(currentErrors);
    const hasNoErrors = Object.keys(currentErrors).length === 0;
    const hasEmailTo = !!(formEMAIL.store_EmailTo ?? "").trim();
    const hasPdf = !!pdfBlob;
    if (!hasNoErrors || !hasEmailTo || !hasPdf) {
      if (currentErrors.store_EmailTo) {
        dispatch(warningErrorAction(t(currentErrors.store_EmailTo)));
      } else if (currentErrors.subjectEmail) {
        dispatch(warningErrorAction(t(currentErrors.subjectEmail)));
      } else if (currentErrors.contentEmail) {
        dispatch(warningErrorAction(t(currentErrors.contentEmail)));
      } else if (!hasPdf) {
        dispatch(warningErrorAction(t("Text_FieldSendFileRequired")));
      } else {
        dispatch(warningErrorAction(t("Text_IncorrectData")));
      }
      return;
    }
    //dispatch(setLoading(true));
    try {
      const base64File = await blobToBase64(pdfBlob);
      const shippingNumber = String(dataShipping.number_shipping ?? "").padStart(8, "0");
      const formData = {
        id,
        defaultStore_id: defaultStore?.id ?? 0,
        useraccount_id: useraccount_id ?? 0,
        store_EmailTo: formEMAIL.store_EmailTo ?? "",
        subjectEmail: formEMAIL.subjectEmail ?? "",
        contentEmail: formEMAIL.contentEmail ?? "",
        filetosend: base64File,
        shippingIds: [Number(id)],
        fileName: `PORTES_${shippingNumber}.pdf`,
        fileType: "application/pdf"
      };
      const getData = await helpHttp().postemail(ENDPOINT, "api/sendemailwithattachment", token, formData);
      dispatch(setLoading(false));
      if (getData?.status === "OK") {
        dispatch(successErrorAction(t("Text_EMAIL_Sended")));
      } else {
        dispatch(warningErrorAction(t(getData?.cause || "Text_IncorrectData")));
      }
      handleCloseSendEmail();
    } catch (error) {
      dispatch(setLoading(false));
      dispatch(warningErrorAction(t("Text_IncorrectData")));
      handleCloseSendEmail();
    }
  }, [validateFormEmail, formEMAIL, pdfBlob, dispatch, t, blobToBase64, id, defaultStore, useraccount_id, token, dataShipping.number_shipping, handleCloseSendEmail]);
  useEffect(() => {
    if (!showModalShippingSendEmail) return;
    const raw = formEMAIL.store_EmailTo ?? "";
    const search = raw.replace(CLEAN_SEARCH_REGEX, "").trim();
    if (!search) {
      setEmailToSelect(initialEmailToSelect);
      setFilteredEmail([]);
      setHighlightedIndexEmail(-1);
      return;
    }
    let cancelled = false;
    const loadEmails = async () => {
      try {
        const getData = await helpHttp().get2(ENDPOINT, "api/getlistemails/", token, search);
        if (cancelled || !mountedRef.current) return;
        if (getData?.err) {
          dispatch(warningErrorAction(t("Text_InvalidCredentials")));
          setEmailToSelect(initialEmailToSelect);
          return;
        }
        setEmailToSelect(Array.isArray(getData) ? getData : initialEmailToSelect);
      } catch (error) {
        if (!cancelled && mountedRef.current) {
          dispatch(warningErrorAction(t("Text_IncorrectData")));
        }
      }
    };
    loadEmails();
    return () => {
      cancelled = true;
    };
  }, [showModalShippingSendEmail, formEMAIL.store_EmailTo, token, dispatch, t]);
  useEffect(() => {
    if (!showModalShippingSendEmail) return;
    let cancelled = false;
    const loadData = async () => {
      //dispatch(setLoading(true));
      try {
        if (id === "0") {
          if (cancelled || !mountedRef.current) return;
          setDataShipping(initialStateShippingSendEmail);
          setFormEMAIL({
            ...initialStateEMAIL,
            defaultStore_id: defaultStore?.id ?? 0,
            useraccount_id: useraccount_id ?? 0,
            store_EmailTo: "",
            subjectEmail: "",
            contentEmail: footeremail ?? ""
          });
          dispatch(setLoading(false));
          return;
        }
        const getData = await helpHttp().get2(ENDPOINT, "shipping/getshippingsendemailbyid/", token, id);
        if (cancelled || !mountedRef.current) return;
        if (getData?.err) {
          setDataShipping(initialStateShippingSendEmail);
          dispatch(warningErrorAction(t(getData?.message === "Load failed" ? "Text_ConnectionFailied" : "Text_InvalidCredentials")));
          dispatch(setLoading(false));
          return;
        }
        const safeShippingData = {
          ...initialStateShippingSendEmail,
          ...getData
        };
        const subjectNumber = safeShippingData.ownshipping_id ?? "";
        setDataShipping(safeShippingData);
        setFormEMAIL({
          ...initialStateEMAIL,
          defaultStore_id: defaultStore?.id ?? 0,
          useraccount_id: useraccount_id ?? 0,
          store_EmailTo: safeShippingData.ori_tras_email ?? "",
          subjectEmail: `LE REMITO LA CARTA DE PORTES Nº: ${subjectNumber}`,
          contentEmail: footeremail ?? ""
        });
        dispatch(setLoading(false));
      } catch (error) {
        if (!cancelled && mountedRef.current) {
          dispatch(setLoading(false));
          dispatch(warningErrorAction(t("Text_IncorrectData")));
        }
      }
    };
    loadData();
    return () => {
      cancelled = true;
    };
  }, [showModalShippingSendEmail, dispatch, id, t, token, defaultStore, useraccount_id, footeremail]);
  const emailToWidth = useMemo(() => {
    return i18n.language === "es" ? 738 : 867;
  }, [i18n.language]);
  const subjectWidth = useMemo(() => {
    return i18n.language === "es" ? 941 : 937;
  }, [i18n.language]);
  const onChangeEmailTo = useCallback(e => {
    const nextValue = (e.target.value ?? "").toLowerCase();
    setFormEMAIL(prev => ({
      ...prev,
      store_EmailTo: nextValue
    }));
    debouncedHandleSearchEmail(nextValue);
  }, [debouncedHandleSearchEmail]);
  const showDropdown = filteredEmail.length > 0;
  const shouldMountReport = useMemo(() => {
    return showModalShippingSendEmail && !!dataShipping.id;
  }, [showModalShippingSendEmail, dataShipping.id]);
  if (!showModalShippingSendEmail) {
    return null;
  }
  return <div className="container-fluid email-send-wrapper shipping-email-form">
      <Box sx={{
      bgcolor: "#ffffff",
      width: "100%",
      maxWidth: "1200px",
      minWidth: 0
    }}>
        <form onSubmit={e => e.preventDefault()}>
          <div className="email-card-header">
            <div className="email-header-content">
              <div className="email-header-icon">
                <i className="fas fa-envelope"></i>
              </div>
              <div className="email-header-text">
                <div className="email-header-title">{t("Text_NumberForm_EMAIL")}:</div>
                <div className="email-header-number">{dataShipping.ownshipping_id ?? ""}</div>
              </div>
              <div className="email-card-actions">
                {!isLoadingData && <>
                    <button type="button" className="email-send-btn" onClick={handleSubmitSendEmail}>
                      {t("Button_Send")}
                      <SendIcon sx={{
                    fontSize: 22,
                    color: "white"
                  }} />
                    </button>
                    <button type="button" className="email-cancel-btn" onClick={handleCloseSendEmail}>
                      {t("Button_Cancel")}
                    </button>
                  </>}
              </div>
            </div>
          </div>
          {!isLoadingData ? <>
              <div className="email-card-form">
                <div className="row g-3">
                  <div className="col-12 email-input" style={{
                position: "relative"
              }}>
                    <label className="text-primary" style={{
                  fontSize: 18
                }}>
                      {t("Text_SENDEMAIL_EmailsTo")} :
                    </label>
                    <TextField id="store_EmailTo" name="store_EmailTo" error={Boolean(errorsEMAIL.store_EmailTo)} value={formEMAIL.store_EmailTo ?? ""} onChange={onChangeEmailTo} onKeyDown={handleKeyDownEmail} onBlur={event => {
                  if (!event.relatedTarget || !event.relatedTarget.closest(".email-suggest-dropdown")) {
                    handleBlurDropdownContainer(event);
                  }
                }} label={errorsEMAIL.store_EmailTo ? t(errorsEMAIL.store_EmailTo) : t("PlaceHolder_SENDEMAIL_EmailsTo")} placeholder={t("PlaceHolder_SENDEMAIL_EmailsTo")} variant="standard" inputProps={{
                  style: {
                    width: emailToWidth
                  },
                  maxLength: 100
                }} InputLabelProps={{
                  style: {
                    fontSize: 18,
                    background: "#FFFFFF"
                  }
                }} />
                    {showDropdown && <div className="email-suggest-dropdown" onMouseDown={e => e.preventDefault()}>
                        {filteredEmail.map((store, index) => {
                    const isActive = index === highlightedIndexEmail;
                    return <MenuItem key={`${store.id ?? index}-${store.email ?? ""}`} onClick={() => handleSelectEmail(store)} onMouseDown={e => e.preventDefault()} style={{
                      cursor: "pointer",
                      padding: "10px 12px",
                      borderBottom: "1px solid #eee",
                      fontSize: 18,
                      backgroundColor: isActive ? "#4e73df" : "transparent",
                      color: isActive ? "white" : "black"
                    }}>
                              {store.email ?? ""}
                            </MenuItem>;
                  })}
                      </div>}
                  </div>
                  <div className="col-12 email-input">
                    <label className="text-primary" style={{
                  fontSize: 18
                }}>
                      {t("Text_SENDEMAIL_Subject")}
                    </label>
                    <TextField id="subjectEmail" name="subjectEmail" error={Boolean(errorsEMAIL.subjectEmail)} value={formEMAIL.subjectEmail ?? ""} onChange={handleChangeDataEditEmail} onBlur={handleBlurDataEditEmail} label={errorsEMAIL.subjectEmail ? t(errorsEMAIL.subjectEmail) : t("PlaceHolder_SENDEMAIL_Subject")} placeholder={t("PlaceHolder_SENDEMAIL_Subject")} variant="standard" inputProps={{
                  style: {
                    width: subjectWidth
                  },
                  maxLength: 100
                }} InputLabelProps={{
                  style: {
                    fontSize: 18,
                    background: "#FFFFFF"
                  }
                }} />
                  </div>
                  <div className="col-12">
                    <label className="text-primary" style={{
                  fontSize: 18
                }}>
                      {t("Text_SENDEMAIL_Content")} :
                    </label>
                    <Textarea id="contentEmail" name="contentEmail" value={formEMAIL.contentEmail ?? ""} className="email-textarea" placeholder={t("PlaceHolder_SENDEMAIL_Content")} sx={{
                  width: "100%",
                  minWidth: 0,
                  fontSize: 18
                }} variant="standard" onChange={handleChangeDataEditEmail} onBlur={handleBlurDataEditEmail} maxRows={8} />
                  </div>
                </div>
              </div>
              <div className="email-card-pdf">{pdfViewer}</div>
            </> : <LoadingNews />}
        </form>
      </Box>
      {shouldMountReport && <ReportTemplateShipping dataShipping={dataShipping} setPdfBlob={setPdfBlob} />}

      <br />
    </div>;
};
ShippingSendEmail.propTypes = {
  id: PropTypes.string.isRequired,
  showModalShippingSendEmail: PropTypes.bool.isRequired
};
export default ShippingSendEmail;